<template>
  <div class="full">
    <div class="login card">
      <div class="login__logo">
        <img src="~@/assets/logo.png" alt />
      </div>
      <v-form v-model="validForm" @submit.prevent="login()">
        <h1 class="login__title card__title">Iniciar Sesión</h1>
        <div class="login__body">
          <span>Usuario:</span>
          <v-text-field v-model="user" required />
          <span>Contraseña:</span>
          <v-text-field v-model="pass" type="password" required />
        </div>
        <div class="login__actions card__actions">
          <v-btn
            :loading="pending"
            :disabled="!validForm"
            color="accent"
            type="submit"
            >Ingresar</v-btn
          >
        </div>
      </v-form>
    </div>
    <!--  -->
    <div class="background"></div>
  </div>
</template>

<script>
import { auth } from "@/services/auth";
import { setSession } from "@/services/session";

export default {
  data: () => ({
    user: "",
    pass: "",
    validForm: false,
    pending: false,
  }),
  methods: {
    async login() {
      this.pending = true;
      auth
        .login({ name: this.user, password: this.pass })
        .then((data) => {
          setSession(data["data"], 0);
          this.$router.push({ name: "events" });
        })
        .catch((m) => {
          const error = m.response.data.detail;
          this.$swal("Oops...", error, "error");
        })
        .finally(() => (this.pending = false));
    },
  }
};
</script>

<style lang="scss" scoped>
.full {
  height: 100vh;
  //
  display: flex;
  flex-direction: row;
}
.login {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 340px;
  padding: 0 30px;
  border-radius: 0;
  z-index: 1;
  //
  display: grid;
  grid-template-rows: 3fr 4fr 3fr;
  justify-content: center;
  align-items: center;

  &__logo {
    padding: 30px 0;
    img {
      display: block;
      margin: 0 auto;
      width: 100px;
    }
  }
  form {
    max-width: 360px;
  }
  &__title {
    font-size: 2rem;
    margin-bottom: 24px;
  }
  &__body {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 12px;
    align-items: center;
  }
  &__actions {
    margin-top: 20px;
  }
}

.background {
  overflow: hidden;
  width: 100%;
  // filter: blur(2px);
  background-image: linear-gradient(
      to right,
      rgba(0, 111, 196, 0.75),
      rgba(0, 111, 196, 0.95)
    ),
    url("~@/assets/background/unmsm.jpg");
  background-size: cover;
  background-position: center center;
}

@media only screen and (max-width: 955px) {
  .login {
    max-width: 100%;
  }
  .background {
    display: none;
  }
}
</style>
